import Vue from 'vue'
import Router from 'vue-router'
import DashboardLayout from '@/layout/DashboardLayout'
import AuthLayout from '@/layout/AuthLayout'
Vue.use(Router);

const router =  new Router({
  linkExactActiveClass: 'active',
  routes: [
    {
      path: '/',
      redirect: 'dashboard',
      component: DashboardLayout,
      children: [
        {
          path: '/dashboard',
          name: 'dashboard',
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () => import(/* webpackChunkName: "demo" */ './views/Dashboard.vue')
        },
          // ImportJob start
          {
              path: '/import-job',
              component: () => import(/* webpackChunkName: "demo" */ './views/ImportJob/ImportJobBase.vue'),
              children: [
                  {
                      path: '',
                      name: 'importJob',
                      component: () => import(/* webpackChunkName: "demo" */ './views/ImportJob/ImportJobTable.vue'),
                  },
                  {
                      path: '/import-ark-invoice/:id',
                      name: 'importArkInvoice',
                      component: () => import(/* webpackChunkName: "demo" */ './views/ImportJob/ImportArkInvoices.vue')
                  },
              ]
          },
          // ImportJob end
          // Correction Invoice start
          {
              path: '/import-correction',
              component: () => import(/* webpackChunkName: "demo" */ './views/ImportJob/ImportJobBase.vue'),
              children: [
                  {
                      path: '',
                      name: 'importCorrection',
                      component: () => import(/* webpackChunkName: "demo" */ './views/CorrectionInvoice/CorrectionInvoiceList.vue'),
                  },
                  {
                      path: '/import-correction/:id',
                      name: 'importCorrectionInvoice',
                      component: () => import(/* webpackChunkName: "demo" */ './views/CorrectionInvoice/ImportCorrectionInvoice.vue')
                  },
              ]
          },
          // Correction Invoice end
          // Users start
          {
              path: '/users',
              component: () => import(/* webpackChunkName: "demo" */ './views/UserManagement/UserList.vue'),
          },
          {
              path: 'users/:id',
              name: 'user',
              component: () => import(/* webpackChunkName: "demo" */ './views/UserManagement/UserForm.vue')
          },
          // Users end
          // Roles start
          {
              path: '/roles',
              component: () => import(/* webpackChunkName: "demo" */ './views/UserManagement/RoleList.vue'),
          },
          {
              path: 'roles/:id',
              name: 'role',
              component: () => import(/* webpackChunkName: "demo" */ './views/UserManagement/RoleForm.vue')
          },
          // Roles end
      ]
    },
    {
      path: '/',
      redirect: 'login',
      component: AuthLayout,
      children: [
        {
          path: '/login',
          name: 'login',
          component: () => import(/* webpackChunkName: "demo" */ './views/Login.vue')
        },
        {
          path: '/register',
          name: 'register',
          component: () => import(/* webpackChunkName: "demo" */ './views/Register.vue')
        }
      ]
    },

  ]
});

router.beforeEach((to, from, next) => {
    // console.log(to, from, next)
    // before each route, check if token exists
    // then on each route check if authetication failed
    if(sessionStorage.getItem("token") === null && to.path !== '/login') {
        next('/login')
    } else {
        next()
    }
});

export default router;